<template>
    <section class="section section-lg overflow-hidden my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container py-0 pb-lg">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-5 mb-5 mb-lg-0">
                    <h1 class="font-weight-light">My Works</h1>
                    <p class="lead mt-4">Here are some of my works.</p>
                </div>
                <div class="col-lg-6 mb-lg-auto">
                    <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                        <b-carousel id="carousel1"
                                    controls
                                    indicators>
                            <!-- Text slides with image -->
                            <b-carousel-slide :img-src="this.getImageUrl('shoda1.jpg')"></b-carousel-slide>
                            <b-carousel-slide :img-src="this.getImageUrl('linkup.jpg')"></b-carousel-slide>
                            <b-carousel-slide :img-src="this.getImageUrl('edrive.jpg')"></b-carousel-slide>
                            <b-carousel-slide :img-src="this.getImageUrl('shega_bet.jpg')"></b-carousel-slide>
                            <b-carousel-slide :img-src="this.getImageUrl('covidet.jpg')"></b-carousel-slide>
                            <b-carousel-slide :img-src="this.getImageUrl('betting.jpg')"></b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  },
  methods: {
      getImageUrl: function (relativePath) {
      return require("@/assets/images/" + relativePath);
    },
  }
};
</script>
<style>
</style>
